// extracted by mini-css-extract-plugin
module.exports =  {"chartContainer":"chartContainer__NGi8J","highcharts-plot-line-label":"highcharts-plot-line-label__kuMLC","footer":"footer__HX6il","reportIcon":"reportIcon__4xjNN"};